import './api/media';

import angular from 'angular';

angular.module('folkeuni').factory('Media', function (MediaApi, $q) {
  
  return {
    getImage: function(imageId) {
      var deferred = $q.defer()
    
        MediaApi.getImage(imageId).then(function (res) {
         
          deferred.resolve(res.data);
        }, function(res) {
          deferred.reject(res);
        });      
      
      return deferred.promise;
    
    },

    buildCropUrl: function(imageObj,crop){
      var cropUrl = "";

      var cropHeight = null;
      cropUrl = imageObj.umbracoFile.src;
      var cropFound = false;
      cropUrl += "?quality=90";
      for (var i = 0; i < imageObj.umbracoFile.crops.length; i++) {
        var currentCrop = imageObj.umbracoFile.crops[i];
        
        if (currentCrop.alias == crop) {
          cropHeight = currentCrop.height;
          if (currentCrop.coordinates) {
            cropUrl += "&crop=" + currentCrop.coordinates.x1 + "," + currentCrop.coordinates.y1 + "," + currentCrop.coordinates.x2 + "," + currentCrop.coordinates.y2;
            cropUrl += "&cropmode=percentage";
            cropUrl += "&height=" + cropHeight;
            cropFound = true;
          }
          if(imageObj.umbracoWidth > imageObj.umbracoHeight){
            if(!cropFound && !imageObj.umbracoFile.focalPoint){
              cropUrl += "&height=" + currentCrop.height;
            }
          }else{              
            cropUrl += "&width=" + currentCrop.width;
          }
          break;
        }
      }
      if (imageObj.umbracoFile.focalPoint && !cropFound) {
        cropUrl += "&anchor=center&mode=crop&center=" + imageObj.umbracoFile.focalPoint.top + "," + imageObj.umbracoFile.focalPoint.left;
        cropUrl += "&height=" + cropHeight;
      }

      return cropUrl
    },

    searchImages: function(query) {
      var deferred = $q.defer()
    
        MediaApi.searchMedia(query).then(function (res) {
          deferred.resolve(res.data);
        }, function(res) {
          deferred.resolve([]);
        });      
      
      return deferred.promise;
    
    }
  };
});
